import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import master_data  from "./master_data";


export default {
    namespaced: true,
    state: {
        groupNonautomateRequest :[],
        detailEachGroup :[],
        warninglabunpublishconditions : [],

        // patho comboset
        groupPathoComboset :[],
        detailEachGroupPathoComboset :[],
        // end patho comboset

    },

    getters: {
    },

    mutations: {
        setDetailEachGroup(state,detailEachGroup){
            state.detailEachGroup = detailEachGroup
        },
        setGroupNonautomate(state,groupNonautomateRequest){
            state.groupNonautomateRequest = groupNonautomateRequest
        },
        setWarninglabUnpublishConditions(state,warninglabunpublishconditions){
            state.warninglabunpublishconditions = warninglabunpublishconditions
        },


        // patho comboset
        setDetailEachGroupPathoComboset(state,detailEachGroupPathoComboset){
            state.detailEachGroupPathoComboset = detailEachGroupPathoComboset
        },
        setGroupPathoComboset(state,groupPathoComboset){
            state.groupPathoComboset = groupPathoComboset
        },
        // end patho comboset





    },

    actions: {
        /* eslint-disable no-console */
        fetchWarninglabUnpublishConditions({commit}){
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/warninglabunpublishconditions`,getConfigAxios())
                    .then((res)=>{
                        commit('setWarninglabUnpublishConditions',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,




        clearDetailEachGroupID({commit}){
            commit('setDetailEachGroup',[])
        },

        fetchDetailEachGroupID({commit},idgrp) {
            const  datTo = {
                "idgrp" : idgrp
            }
            return new Promise((resolve) => {

                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/getlistofdetailgroupnonautomate`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setDetailEachGroup',res.data)
                    })
                    .catch(err =>{
                        console.log("err")
                        console.log(err)
                    })
                resolve()
            })
        },


        clearGroupNonautomateRequest({commit}){
            commit('setGroupNonautomate',[])
        },
        fetchGroupNonautomateRequest({commit}) {
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/getgrouplabnonautomate`,getConfigAxios())
                    .then((res)=>{
                        commit('setGroupNonautomate',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })

            })
        } ,





        // patho comboset
        clearDetailEachGroupPathoComboset({commit}){
            commit('setDetailEachGroupPathoComboset',[])
        },

        fetchDetailEachGroupPathoComboset({commit},idgrp) {
            const  datTo = {
                "idgrp" : idgrp
            }
            return new Promise((resolve) => {

                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/getlistofdetailgrouppatho`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setDetailEachGroupPathoComboset',res.data)
                    })
                    .catch(err =>{
                        console.log("err")
                        console.log(err)
                    })
                resolve()
            })
        },


        clearGroupPathoComboset({commit}){
            commit('setGroupPathoComboset',[])
        },
        fetchGroupPathoComboset({commit},payload) {
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/getgrouplabpatho`,payload,getConfigAxios())
                    .then((res)=>{
                        commit('setGroupPathoComboset',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })

            })
        } ,

        // end patho comboset  

    }
}